import React from 'react';
import { Button } from '@cloudscape-design/components';

const FloatingChatButton = ({ onClick }) => {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        zIndex: 1000,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        borderRadius: '50%'
      }}
    >
      <Button
        variant="primary"
        iconName="contact"
        onClick={onClick}
        ariaLabel="Open AI Assistant"
        style={{
          borderRadius: '50%',
          width: '56px',
          height: '56px',
          padding: '0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      />
    </div>
  );
};

export default FloatingChatButton;